module.exports=function(it){if(typeof it!='function'){throw TypeError(String(it)+' is not a function');}return it;};